import { Button, styled } from '@mui/material';

export const MuiButtonStyled = styled(Button)(({ theme }) => ({
  lineHeight: 1,

  '&:hover': {
    color: `${theme.palette.colors.highlight} !important`,
  },
}));
